"use client";
import { Box, Stack, Heading, Text } from "@chakra-ui/react";
import Image from "next/image";
import PageLayout from "@/layouts/pageLayout";
import { Button } from "@/elements";
import { scrollToElement } from "@/utils/scrollToElement";
import { HERO_CONSTANTS } from "./constants";

const HeroComp = () => {
  const { heading, title, subText, btn1, btn2, image } = HERO_CONSTANTS;
  return (
    <Box
      position="relative"
      minH={{ base: "440px", md: "500px" }}
      color="white"
      overflow="hidden"
    >
      <Box position="absolute" inset="0" bg="brand.200" zIndex={-2} />
      {image && (
        <Image
          src={image}
          alt="Hero background"
          fill
          priority
          quality={75}
          style={{ objectFit: "cover", zIndex: -1 }}
        />
      )}
      <PageLayout>
        <Stack gap={8} justify={"center"} align="center" py={{ base: 8, sm: 16 }}>
          <Text fontSize="sm" color="#68D585">
            {heading}
          </Text>
          <Heading
            as="h1"
            fontSize={{ base: "38px", md: "48px" }}
            lineHeight={{ base: "40px", md: "54px", lg: "58px" }}
            fontWeight={700}
            whiteSpace="pre-line"
          >
            {title}
          </Heading>
          <Text fontSize="24px" lineHeight="30px" fontWeight={300} whiteSpace="pre-line">
            {subText}
          </Text>
          <Stack gap={{ base: 2, md: 6 }} direction={{ base: "column", md: "row" }}>
            <Button
              onClick={() => scrollToElement(btn1.link as string, 120)}
              variant={"outline"}
              fontSize={"17px"}
              borderRadius={"8px"}
              whiteSpace="normal"
              w="fit-content"
              py={{ base: 5 }}
            >
              {btn1.label}
            </Button>

            <Button
              onClick={() => scrollToElement(btn2.link, 120)}
              variant={"outline"}
              fontSize={"17px"}
              borderRadius={"8px"}
              whiteSpace="normal"
              w="fit-content"
              py={{ base: 5 }}
              bgColor={"#F74D4D"}
            >
              {btn2.label}
            </Button>
          </Stack>
        </Stack>
      </PageLayout>
    </Box>
  );
};

export default HeroComp;
